import ChandraSuryaLogo from '../Images/ChandraSuryaFC.jpg';
import EverestUnitedLogo from '../Images/EverestUnitedClub.jpg';
import NorthPeakLogo from '../Images/NorthPeakFC.jpg';
import CraigieburnBrigadeLogo from '../Images/CraigieburnBrigadeSC.jpg';
import AdelaideEverestLogo from '../Images/AdelaideEverestFC.jpg';
import CairnsBhutaneseLogo from '../Images/CairnsBhutaneseFC.jpg';
import BlackEaglesLogo from '../Images/BlackEaglesFC.png';
import TheHimalayanTigersLogo from '../Images/TheHimalayanTiger.jpg';
import ZimbabweLogo from '../Images/ZimbabweFC.png';
import MarsLogo from '../Images/MarsFC.png';
import RoyaleLogo from '../Images/RoyaleFC.jpg';
import MTUCROCSLogo from '../Images/MtuCrocs.png';
import HimalayanLogo from '../Images/HimalayanFC.jpg';
import UnitedLogo from '../Images/UnitedFC.jpg';
import GhanUnitedLogo from '../Images/GhanUnited.png';
import UmojaStarsLogo from '../Images/UmojaStars.png';
import DandyStrikersLogo from '../Images/DandyStrikers.png';
import KabulStarsLogo from '../Images/KabulStarsFC.png';
import WestMelbourneLogo from '../Images/WestMelbourneFC.png';


export const matches = [
  // MCSA Silicon Stack Premier League 2026
  {
    id: 22,
    date: '2026-04-26',
    time: '3:30 pm',
    opponent: 'MTU CROCS',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '1-3',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: MTUCROCSLogo
  },
  {
    id: 23,
    date: '2026-05-03',
    time: '4:00 pm',
    opponent: 'Ghan United',
    venue: 'Away - Ghan United Stadium',
    type: 'past',
    score: '1-1',
    result: 'Draw',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: GhanUnitedLogo
  },
  {
    id: 24,
    date: '2026-05-10',
    time: '1:30 pm',
    opponent: 'Umoja Stars',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '2-0',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: UmojaStarsLogo
  },
  {
    id: 25,
    date: '2026-05-24',
    time: '1:00 pm',
    opponent: 'Dandy Strikers',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '0-4',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: DandyStrikersLogo
  },
  {
    id: 26,
    date: '2026-05-31',
    time: '1:00 pm',
    opponent: 'Craigieburn Brigade',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '0-7',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: CraigieburnBrigadeLogo
  },
  {
    id: 27,
    date: '2026-06-14',
    time: '3:00 pm',
    opponent: 'Royale FC',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '2-2',
    result: 'Draw',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: RoyaleLogo
  },
  {
    id: 28,
    date: '2026-06-21',
    time: '3:00 pm',
    opponent: 'Himalayan FC',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '0-8',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: HimalayanLogo
  },
  {
    id: 29,
    date: '2026-06-28',
    time: '12:01 am',
    opponent: 'Kabul Stars FC',
    venue: 'Darebin International Sports Centre',
    type: 'past',
    score: '0-3',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: KabulStarsLogo
  },
  {
    id: 30,
    date: '2026-07-05',
    time: '1:00 pm',
    opponent: 'Mars FC',
    venue: 'Knox Regional Football Centre',
    type: 'past',
    score: '0-5',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: MarsLogo
  },
  {
    id: 31,
    date: '2026-07-12',
    time: '3:00 pm',
    opponent: 'West Melbourne FC',
    venue: 'RMIT Sports Centre',
    type: 'past',
    score: '2-0',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2026',
    opponentLogo: WestMelbourneLogo
  },
  // Champion Showdown 2025 - 14 December 2025
  {
    id: 1,
    date: '2025-12-14',
    time: '18:00',
    opponent: 'Chandra Surya FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-1',
    result: 'Loss',
    league: 'Championship Showdown 2025',
    opponentLogo: ChandraSuryaLogo
  },
  {
    id: 2,
    date: '2025-12-14',
    time: '19:00',
    opponent: 'Everest United FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '2-0',
    result: 'Win',
    league: 'Championship Showdown 2025',
    opponentLogo: EverestUnitedLogo
  },
  {
    id: 3,
    date: '2025-12-14',
    time: '20:00',
    opponent: 'North Peak FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '1-1',
    result: 'Draw',
    league: 'Championship Showdown 2025',
    opponentLogo: NorthPeakLogo
  },
  {
    id: 4,
    date: '2025-12-14',
    time: '21:00',
    opponent: 'Craigieburn Brigade SC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-4',
    result: 'Loss',
    league: 'Championship Showdown 2025',
    opponentLogo: CraigieburnBrigadeLogo
  },
  // 12th Interstate Bhutanese Interstate - 26 September 2025
  {
    id: 5,
    date: '2025-09-26',
    time: '18:00',
    opponent: 'Adelaide Everest FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-0',
    result: 'Draw',
    league: '12th Interstate Bhutanese Interstate',
    opponentLogo: AdelaideEverestLogo
  },
  {
    id: 6,
    date: '2025-09-26',
    time: '19:00',
    opponent: 'Cairns Bhutanese FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-0',
    result: 'Draw',
    league: '12th Interstate Bhutanese Interstate',
    opponentLogo: CairnsBhutaneseLogo
  },
  // MCSA Silicon Stack Premier League 2025
  {
    id: 7,
    date: '2025-09-14',
    time: '15:00',
    opponent: 'Black Eagles FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-5',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: BlackEaglesLogo
  },
  {
    id: 8,
    date: '2025-08-31',
    time: '15:00',
    opponent: 'The Himalayan Tigers',
    venue: 'Away - The Himalayan Tigers Stadium',
    type: 'past',
    score: '3-3',
    result: 'Draw',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: TheHimalayanTigersLogo
  },
  {
    id: 9,
    date: '2025-08-24',
    time: '12:00',
    opponent: 'Zimbabwe FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '3-0',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: ZimbabweLogo
  },
  {
    id: 10,
    date: '2025-08-17',
    time: '14:00',
    opponent: 'Mars FC',
    venue: 'Away - Mars FC Stadium',
    type: 'past',
    score: '1-8',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: MarsLogo
  },
  {
    id: 11,
    date: '2025-08-10',
    time: '13:00',
    opponent: 'Royale FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-4',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: RoyaleLogo
  },
  {
    id: 12,
    date: '2025-08-03',
    time: '00:01',
    opponent: 'MTU CROCS',
    venue: 'Away - MTU CROCS Stadium',
    type: 'past',
    score: '3-0',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: MTUCROCSLogo
  },
  {
    id: 13,
    date: '2025-07-27',
    time: '13:00',
    opponent: 'Himalayan FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '3-1',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: HimalayanLogo
  },
  {
    id: 14,
    date: '2025-07-20',
    time: '15:00',
    opponent: 'Black Eagles FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '1-3',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: BlackEaglesLogo
  },
  {
    id: 15,
    date: '2025-07-13',
    time: '15:00',
    opponent: 'Craigieburn Brigade',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '1-4',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: CraigieburnBrigadeLogo
  },
  {
    id: 16,
    date: '2025-07-06',
    time: '11:00',
    opponent: 'United FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-4',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: UnitedLogo
  },
  {
    id: 17,
    date: '2025-06-29',
    time: '15:00',
    opponent: 'The Himalayan Tigers',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '1-2',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: TheHimalayanTigersLogo
  },
  {
    id: 18,
    date: '2025-06-22',
    time: '00:00',
    opponent: 'Zimbabwe FC',
    venue: 'Away - Zimbabwe FC Stadium',
    type: 'past',
    score: '3-0',
    result: 'Win',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: ZimbabweLogo
  },
  {
    id: 19,
    date: '2025-06-15',
    time: '12:00',
    opponent: 'Mars FC',
    venue: 'Home - Main Stadium',
    type: 'past',
    score: '0-3',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: MarsLogo
  },
  {
    id: 20,
    date: '2025-06-01',
    time: '13:00',
    opponent: 'Royale FC',
    venue: 'Away - Royale FC Stadium',
    type: 'past',
    score: '2-3',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: RoyaleLogo
  },
  {
    id: 21,
    date: '2025-05-25',
    time: '11:00',
    opponent: 'Himalayan FC',
    venue: 'Away - Himalayan FC Stadium',
    type: 'past',
    score: '1-2',
    result: 'Loss',
    league: 'MCSA Silicon Stack Premier League 2025',
    opponentLogo: HimalayanLogo
  }
];
